export default "__VITE_ASSET__BbHDGa_9__"